import React, { useContext, useEffect, useState } from 'react';
import instance from '../Config/AxiosConfig';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import { AuthContext } from '../Context/AuthProvider';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Sidebar from '../Layouts/Sidebar';
import TopBar from '../Layouts/TopBar';

function UpdatePublication() {
    const [type, setType] = useState([]);
    const [formData, setFormData] = useState({
        title: '',
        documentType: '',
        file: null,
        publicationDate: '',
        documentDoi: '',
    });
    const [errors, setErrors] = useState({});
    const { user } = useContext(AuthContext);

    const { id } = useParams(); // Récupérer l'ID de la publication à partir de l'URL

    // Récupérer les types de publication et les données de la publication à mettre à jour
    useEffect(() => {
        const token = Cookies.get('token');
        // Récupérer les types de publication
        instance.get("/articles/getAllTypes", token)


            .then(response => setType(response.data))
            .catch(error => {
                console.error('Erreur lors de la récupération des types:', error);
            });

        //Récupérer les données de la publication existante
        instance.get(`/articles/get/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then(response => {
                const publication = response.data;
                setFormData({
                    title: publication.titleText,
                    documentType: publication.documentType,
                    file: publication.file, // Les fichiers doivent être téléchargés à nouveau
                    publicationDate: publication.publicationDate,
                    documentDoi: publication.documentDoi,
                });
            })
            .catch(error => {
                console.error('Erreur lors de la récupération de la publication:', error);
            });
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setFormData(prevState => ({
            ...prevState,
            file: file
        }));
    };

    // const validateForm = () => {
    //     const errors = {};
    //     if (!formData.title) errors.title = 'Article name is required';
    //     if (!formData.documentType) errors.documentType = 'Article type is required';
    //     if (!formData.date) errors.date = 'Date is required';
    //     if (!formData.doi) errors.doi = 'DOI is required';
    //     return errors;
    // };
    console.log(formData, 'formDataformDataformDataformDataformDataformData');

    const history = useHistory()
    const handleSubmit = async (e) => {
        e.preventDefault();
        // const validationErrors = validateForm();
        // if (Object.keys(validationErrors).length > 0) {
        //     setErrors(validationErrors);
        //     return;
        // }

        const token = Cookies.get('token');
        const data = new FormData();
        data.append('title', formData.title);
        data.append('documentType', formData.documentType);
        data.append('documentDoi', formData.documentDoi);
        data.append('publicationDate', formData.publicationDate);
        data.append('id', id);

        if (formData.file) {
            data.append('file', formData.file); // Ajoute le fichier seulement si un nouveau fichier a été sélectionné
        }

        try {
            const response = await instance.post('/articles/update', data, token)
            console.log(response, "responseresponseresponseresponseresponse");

            if (response.status === 200) {
                Swal.fire({
                    text: "Article updated successfully!",
                    icon: "success"
                });

                setErrors({});

                history.push(`/myprofil/${user.id}`);
            } else {
                Swal.fire({
                    title: "Error!",
                    text: "Failed to update article.",
                    icon: "error"
                });
                setErrors({ form: 'Failed to update article. Error from server.' });
            }
        } catch (error) {
            console.error('Error updating article:', error);
            setErrors({ form: 'An error occurred while updating the article.' });
        }
    };

    return (
        <>
            <TopBar />
            <main>
                <div class="container">
                    <div class="row g-4">

                        <div className="col-lg-3">
                            <Sidebar />
                        </div>

                        <div className="col-md-8 col-lg-6 vstack gap-4">
                            {/* Create a project START */}
                            <div className="card">
                                {/* Title START */}
                                <div className="card-header border-0 pb-0">

                                    <h1 className="h4 card-title mb-0">Update  Publication</h1>

                                </div>

                                <div className="card-body">
                                    {errors.form && <p style={{ color: 'red' }}>{errors.form}</p>}

                                    <form className="row g-3" onSubmit={handleSubmit}>
                                        <div className="col-12">
                                            <label className="form-label">Publication Title</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="title"
                                                value={formData.title}
                                                onChange={handleChange}
                                                placeholder="Publication title"
                                            />
                                            {errors.titleText && <small style={{ color: 'red' }}>{errors.titleText}</small>}
                                        </div>

                                        <div className="col-12">
                                            <label className="form-label">Publication Type</label>
                                            <select
                                                className="form-select"
                                                name="documentType"
                                                value={formData.documentType}
                                                onChange={handleChange}
                                            >
                                                <option value="">Select type</option>
                                                {type.map((c, i) => (
                                                    <option key={i} value={c.id}>{c.type}</option>
                                                ))}
                                            </select>
                                            {errors.documentType && <small style={{ color: 'red' }}>{errors.documentType}</small>}
                                        </div>

                                        <div className="col-12">
                                            <label className="form-label">DOI</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="documentDoi"
                                                value={formData.documentDoi}
                                                onChange={handleChange}
                                                placeholder="Publication DOI "
                                            />
                                            {errors.doi && <small style={{ color: 'red' }}>{errors.doi}</small>}
                                        </div>

                                        <div className="col-12">
  <label className="form-label">Upload File</label>
  <input
    type="file"
    className="form-control"
    name="file"
    onChange={handleFileChange}
  />

  {/* Display the file name instead of the file object */}
  {formData.file && <p>{formData.file.name}</p>} 

  {errors.file && <small style={{ color: 'red' }}>{errors.file}</small>}
</div>


                                        <div className="col-sm-6 col-12">
                                            <label className="form-label">Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="publicationDate"
                                                value={formData.publicationDate}
                                                onChange={handleChange}
                                            />
                                            {errors.publicationDate && <small style={{ color: 'red' }}>{errors.publicationDate}</small>}
                                        </div>

                                        <div className="col-12 text-end">
                                            <button type="submit" className="btn btn-primary mb-0">Update</button>
                                        </div>
                                    </form>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>

                {/* Container END */}
            </main>
        </>
    );
}

export default UpdatePublication;
